/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CardBrand/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Amex from './Amex/index'
import Discover from './Discover/index'
import Mastercard from './Mastercard/index'
import No from './No/index'
import React from 'react'
import Visa from './Visa/index'



/** @type {import('Simple/types.js').View} */
export default function CardBrand({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let reusableMethodCardBrandValueData = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'card_brand',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: reusableMethodCardBrandValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Amex'}>
<Amex
  viewPath={`${viewPath}/Amex`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Mastercard'}>
<Mastercard
  viewPath={`${viewPath}/Mastercard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Discover'}>
<Discover
  viewPath={`${viewPath}/Discover`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Visa'}>
<Visa
  viewPath={`${viewPath}/Visa`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}